import useModal from '../../hooks/useModal';
import { useSetupSignlessTrading } from 'src/hooks/wallets/privy/useSetupSignlessTrading';
import { useCallback, useState } from 'react';
import { EnableSignlessTradingStepCard } from './EnableSignlessTradingStepCard';
import ResponsiveModal from '../../ResponsiveModal/ResponsiveModal';
import Button from 'src/components/primitives/Button/Button';
import Checkbox from 'src/components/primitives/Checkbox/Checkbox';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';
import { useDebounce } from 'react-use';

export default function EnableSignlessTradingModal() {
	const { hide } = useModal();
	const {
		connectToPrivy,
		setupDelegates,
		connectingToPrivyState,
		settingUpDelegatesState,
	} = useSetupSignlessTrading();

	const [isLedgerWallet, setIsLedgerWallet] = useState(false);

	const isLedgerRef = useSyncedRef(isLedgerWallet);

	useDebounce(
		() => {
			setupDelegates(isLedgerRef.current).then((result) => {
				if (result) {
					hide();
				}
			});
		},
		500, // we debounce to prevent multiple calls to setupDelegates
		[setupDelegates, hide]
	);

	const handleSignInPrivy = useCallback(() => {
		connectToPrivy(isLedgerWallet);
	}, [connectToPrivy, isLedgerWallet]);

	return (
		<ResponsiveModal.Container
			onClose={hide}
			dataTestId="enable-signless-trading-modal"
		>
			<ResponsiveModal.Title closeButtonTestId="enable-signless-trading-modal-close">
				Enable Trading
			</ResponsiveModal.Title>
			<ResponsiveModal.Body>
				<p>
					Two signatures are required to verify your ownership and enable
					Auto-Signing while trading on Drift.
				</p>

				<EnableSignlessTradingStepCard
					title="Establish Connection"
					description="Sign this message to verify ownership of your Drift account"
					state={connectingToPrivyState}
				/>
				<EnableSignlessTradingStepCard
					title="Enable Auto-Signing"
					description="Sign this transaction to enable gasless and signless trading on Drift"
					state={settingUpDelegatesState}
				/>
			</ResponsiveModal.Body>

			<ResponsiveModal.Footer className="flex-col items-stretch">
				<Checkbox.Default
					id="ledger-wallet-checkbox"
					checked={isLedgerWallet}
					onCheckedChange={() => setIsLedgerWallet((prev) => !prev)}
					label="I'm using a Ledger hardware wallet"
				/>

				<Button
					size="lg"
					onClick={handleSignInPrivy}
					dataTestId="enable-signless-trading-modal-submit"
				>
					Confirm
				</Button>
			</ResponsiveModal.Footer>
		</ResponsiveModal.Container>
	);
}
